import React, { useEffect, useState, useRef } from "react";
import Posts from "../component/home/Posts";
import { useDispatch, useSelector } from "react-redux";
import { getHomePosts } from "../slices/2-post/thunk";
import SectionLoader from "../component/sharedComponents/Loading/SectionLoader";

const Home = () => {
  const dispatch = useDispatch();
  const { posts, pagination, loading } = useSelector((state) => state.posts);
  const { query, filter } = useSelector((state) => state.search);

  const [isFetchingMore, setIsFetchingMore] = useState(false);

  const paginationRef = useRef(pagination);

  // keep ref updated
  useEffect(() => {
    paginationRef.current = pagination;
  }, [pagination]);

  // Initial load
  useEffect(() => {
    dispatch(getHomePosts({ limit: 10, page: 1, search: query, filter }));
  }, [dispatch, query, filter]);

  // Infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      const { hasNextPage, nextPage } = paginationRef.current || {};
      if (!hasNextPage || isFetchingMore) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= docHeight * 0.9) {
        setIsFetchingMore(true);

        dispatch(
          getHomePosts({
            limit: 10,
            page: nextPage,
            search: query,
            filter,
          })
        ).finally(() => {
          setIsFetchingMore(false);
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [dispatch, isFetchingMore, query, filter]);

  if (loading && posts.length === 0) {
    return <SectionLoader />;
  }

  return (
    <>
      <Posts posts={posts} tab={true} />
      {isFetchingMore && <SectionLoader />}
    </>
  );
};

export default Home;
